import { useState } from "react"
import { Bell } from "lucide-react"
import { useNotificationsInbox } from "@/entities/notification"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shared/components/ui/popover"
import { Badge } from "@/shared/components/ui/badge"
import { NotificationPanel } from "./NotificationPanel"

export function NotificationBell() {
  const [open, setOpen] = useState(false)
  const { data } = useNotificationsInbox(1, 20)
  const unreadCount = data?.unreadCount ?? 0

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="relative flex h-9 w-9 items-center justify-center rounded-md text-ink-2 hover:bg-hover"
          aria-label="Notifications"
        >
          <Bell size={15} strokeWidth={1.6} />
          {unreadCount > 0 && (
            <Badge
              tone="bad"
              className="absolute -right-0.5 -top-0.5 h-4 min-w-4 justify-center rounded-full px-1 py-0 text-[10px] leading-none"
            >
              {unreadCount > 9 ? "9+" : unreadCount}
            </Badge>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[360px] overflow-hidden p-0">
        <NotificationPanel onClose={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  )
}
